import exchangeRates from "@/data/exchange-rates-ccy-to-sgd.json";

export const exchangeCurrency = (fromAmount, fromCurrency, toCurrency) => {
  if (!fromCurrency || !toCurrency) throw new Error("Currency not provided");
  if (!fromAmount) return 0;

  const amountInSGD = fromAmount * exchangeRates[fromCurrency.toUpperCase()];
  return amountInSGD / exchangeRates[toCurrency.toUpperCase()];
};
